import Bug16Icon from "@atlaskit/icon-object/glyph/bug/16";
import Story16Icon from "@atlaskit/icon-object/glyph/story/16";
import Task16Icon from "@atlaskit/icon-object/glyph/task/16";
import Lozenge from "@atlaskit/lozenge";
import { B200, G300, P200 } from "@atlaskit/theme/colors";

import {
    PriorityBlocker24Icon,
    PriorityCritical24Icon,
    PriorityHigh16Icon,
    PriorityMinor24Icon,
    ProjectTeamRocket24Image,
    AssigneeAlvin24Image,
    AssigneeBlake24Image,
    AssigneeJane24Image
} from "../assets";
import { Block24Icon } from "../assets/icon-block";
import { Message } from "../constants/types";
import { Assignee, EpicName, IssueTypeName, Priority } from "../constants/ui";

export const getAssetOptionsForProject = (
    value: string,
    messages: Message,
    includeLabel: boolean
) => {
    const { createIssueModalProjectAssetLabel1 } = includeLabel
        ? messages
        : {
              createIssueModalProjectAssetLabel1: ""
          };
    switch (value) {
        default:
            return (
                <ProjectTeamRocket24Image
                    alt={createIssueModalProjectAssetLabel1}
                />
            );
    }
};

export const getAssetOptionsForIssueType = (
    value: string | undefined,
    messages: Message,
    includeLabel: boolean
) => {
    const {
        createIssueModalIssueTypeAssetLabel1,
        createIssueModalIssueTypeAssetLabel2,
        createIssueModalIssueTypeAssetLabel3
    } = includeLabel
        ? messages
        : {
              createIssueModalIssueTypeAssetLabel1: "",
              createIssueModalIssueTypeAssetLabel2: "",
              createIssueModalIssueTypeAssetLabel3: ""
          };
    switch (value) {
        case IssueTypeName.TASK:
            return <Task16Icon label={createIssueModalIssueTypeAssetLabel1} />;
        case IssueTypeName.STORY:
            return <Story16Icon label={createIssueModalIssueTypeAssetLabel2} />;
        case IssueTypeName.BUG:
            return <Bug16Icon label={createIssueModalIssueTypeAssetLabel3} />;
        default:
            console.warn(`Asset for issue type ${value} does not exist.`);
            return <Task16Icon label={createIssueModalIssueTypeAssetLabel1} />;
    }
};

export const getAssetOptionsForPriority = (
    value: string | undefined,
    messages: Message,
    includeLabel: boolean
) => {
    const {
        createIssueModalPriorityAssetLabel1,
        createIssueModalPriorityAssetLabel2,
        createIssueModalPriorityAssetLabel3,
        createIssueModalPriorityAssetLabel4
    } = includeLabel
        ? messages
        : {
              createIssueModalPriorityAssetLabel1: "",
              createIssueModalPriorityAssetLabel2: "",
              createIssueModalPriorityAssetLabel3: "",
              createIssueModalPriorityAssetLabel4: ""
          };
    switch (value) {
        case Priority.HIGH:
            return (
                <PriorityHigh16Icon
                    label={createIssueModalPriorityAssetLabel1}
                />
            );
        case Priority.CRITICAL:
            return (
                <PriorityCritical24Icon
                    label={createIssueModalPriorityAssetLabel2}
                />
            );
        case Priority.BLOCKER:
            return (
                <PriorityBlocker24Icon
                    label={createIssueModalPriorityAssetLabel3}
                />
            );
        case Priority.MINOR:
            return (
                <PriorityMinor24Icon
                    label={createIssueModalPriorityAssetLabel4}
                />
            );
        default:
            console.warn(`Asset for priority ${value} does not exist.`);
            return (
                <PriorityMinor24Icon
                    label={createIssueModalPriorityAssetLabel1}
                />
            );
    }
};

export const getAssetOptionsForAssignee = (
    value: string | undefined,
    messages: Message,
    includeLabel: boolean
) => {
    const {
        createIssueModalAssigneeAssetLabel1,
        createIssueModalAssigneeAssetLabel2,
        createIssueModalAssigneeAssetLabel3
    } = includeLabel
        ? messages
        : {
              createIssueModalAssigneeAssetLabel1: "",
              createIssueModalAssigneeAssetLabel2: "",
              createIssueModalAssigneeAssetLabel3: ""
          };
    switch (value) {
        case Assignee.ALVIN:
            return (
                <AssigneeAlvin24Image
                    alt={createIssueModalAssigneeAssetLabel1}
                />
            );
        case Assignee.JANE:
            return (
                <AssigneeJane24Image
                    alt={createIssueModalAssigneeAssetLabel2}
                />
            );
        case Assignee.BLAKE:
            return (
                <AssigneeBlake24Image
                    alt={createIssueModalAssigneeAssetLabel3}
                />
            );
        default:
            console.warn(`Asset for assignee ${value} does not exist.`);
            return (
                <AssigneeAlvin24Image
                    alt={createIssueModalAssigneeAssetLabel1}
                />
            );
    }
};

export const getAssetOptionsForEpicLink = (
    value: string,
    messages: Message,
    includeLabel: boolean
) => {
    const {
        createIssueModalEpicLinkAssetLabel1,
        createIssueModalEpicLinkAssetLabel2,
        createIssueModalEpicLinkAssetLabel3
    } = includeLabel
        ? messages
        : {
              createIssueModalEpicLinkAssetLabel1: "",
              createIssueModalEpicLinkAssetLabel2: "",
              createIssueModalEpicLinkAssetLabel3: ""
          };
    switch (value) {
        case EpicName.FEATURES:
            return (
                <Block24Icon
                    color={B200}
                    label={createIssueModalEpicLinkAssetLabel1}
                />
            );
        case EpicName.ANALYTICS:
            return (
                <Block24Icon
                    color={G300}
                    label={createIssueModalEpicLinkAssetLabel2}
                />
            );
        case EpicName.PAYMENTS:
            return (
                <Block24Icon
                    color={P200}
                    label={createIssueModalEpicLinkAssetLabel3}
                />
            );
        default:
            console.warn(`Asset for epic link ${value} does not exist.`);
            return (
                <Block24Icon
                    color={B200}
                    label={createIssueModalEpicLinkAssetLabel1}
                />
            );
    }
};

export const getAssetForEpicLink = (value: string | undefined) => {
    switch (value) {
        case EpicName.FEATURES:
            return (
                <Lozenge appearance={"inprogress"} isBold>
                    {value}
                </Lozenge>
            );
        case EpicName.ANALYTICS:
            return (
                <Lozenge appearance={"success"} isBold>
                    {value}
                </Lozenge>
            );
        case EpicName.PAYMENTS:
            return (
                <Lozenge appearance={"new"} isBold>
                    {value}
                </Lozenge>
            );
        default:
            console.warn(`Asset for epic link ${value} does not exist.`);
            return (
                <Lozenge appearance={"inprogress"} isBold>
                    {value}
                </Lozenge>
            );
    }
};
